import {Component} from '@angular/core';
import {RestApiService} from '../../../services/api/rest-api.service';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {MediaSource, MediaSourceType} from '../../../models/media-source';
import {InputComponent} from '../../form/input/input.component';
import {ActionButtonComponent} from '../../form/action-buttons/action-button.component';
import {ConfirmationService, PrimeTemplate} from 'primeng/api';
import {downloadFile} from '../../../utils/download-utils';

@Component({
  standalone: true,
  selector: 'app-media-form',
  imports: [
    InputComponent,
    ActionButtonComponent,
  ],
  templateUrl: './media-form.component.html',
  styleUrl: './media-form.component.scss'
})
export class MediaFormComponent {

  loading = false;
  mediaSource: MediaSource = null!;


  constructor(private api: RestApiService,
              private confirmationService: ConfirmationService,
              private dynamicDialogRef: DynamicDialogRef, private config: DynamicDialogConfig) {
    this.mediaSource = (config.data as Configuration).mediaSource;
  }

  protected readonly MediaSourceType = MediaSourceType;

  confirmSelection() {
    this.update();
    if (!this.mediaSource.deleted) {
      this.dynamicDialogRef.close(this.mediaSource);
    } else {
      this.dynamicDialogRef.close('reload');
    }
  }

  cancelSelection(reload = false) {
    this.dynamicDialogRef.close(reload ? 'reload' : null);
  }

  async update() {
    await this.api.mediaSources.update(this.mediaSource);
  }

  delete() {
    this.confirmationService.confirm({
      header: 'Sei sicuro di voler eliminare questo media?',
      message: 'Il media verrà spostato nel cestino.',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Delete',
      rejectLabel: 'Cancel',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      acceptIcon: 'pi pi-trash',
      rejectIcon: 'pi pi-times',
      accept: async () => {
        await this.api.mediaSources.deleteById(this.mediaSource.mediaSourceId);
        this.cancelSelection(true);
      },
    });
  }

  async download() {
    await downloadFile(this.api.mediaSources.download(this.mediaSource.mediaSourceId));
    this.cancelSelection(true);
  }

  restore() {
    this.confirmationService.confirm({
      header: 'Sei sicuro di voler ripristinare questo media?',
      message: 'Il media verrà ripristinato e sarà nuovamente disponibile.',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Restore',
      rejectLabel: 'Cancel',
      acceptButtonStyleClass: 'p-button-success',
      rejectButtonStyleClass: 'p-button-secondary',
      acceptIcon: 'pi pi-refresh',
      rejectIcon: 'pi pi-times',
      accept: async () => {
        await this.api.mediaSources.restoreById(this.mediaSource.mediaSourceId);
        this.cancelSelection(true);
      },
    });
  }

  static openDialog(dialogService: DialogService,
                    mediaSource: MediaSource
  ): DynamicDialogRef {
    return dialogService.open(MediaFormComponent, {
      width: '60%',
      closable: true,
      closeOnEscape: true,
      header: 'Media file',
      modal: true,
      showHeader: true,
      data: {
        mediaSource: mediaSource
      } as Configuration
    });
  }

}

interface Configuration {
  mediaSource: MediaSource,
}
